var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsCloudformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B612D;}\r\n\t.st1{fill:#759C3E;}\r\n\t.st2{fill:#749B3E;}\r\n\t.st3{fill:#3D4B2A;}\r\n\t.st4{fill:#B6C99C;}\r\n\t.st5{fill:#4B612C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,75.3c-1-0.3-2-0.9-2.9-1.4c-7.1-3.6-14.3-7.2-21.4-10.8c-0.5-0.3-0.7-0.5-0.7-1.1c0-11.4,0-22.7,0-34.1 c0-0.5,0.1-0.8,0.6-1.1c8-4,15.9-8,23.8-12c0.2-0.1,0.4-0.2,0.6-0.2C65,34.9,65,55.1,65,75.3z M43.3,56.7c4.3,1.3,8.7,2.6,13,3.9 c1.4,0.4,1.4,0.4,1.4-1c0-0.7,0-1.5,0-2.2c0-8.3,0-16.6,0-24.9c0-0.9,0-1.9,0-2.8c0-0.6-0.2-0.8-0.8-0.6 c-4.2,1.3-8.4,2.5-12.6,3.8c-0.2,0.1-0.5,0.2-0.5,0.5c-0.6-0.2-0.7,0-0.7,0.6c0,7.3,0,14.6,0,21.9C43.1,56.3,43,56.6,43.3,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,75.3c0-20.2,0-40.4,0-60.6c2.4,1.2,4.8,2.4,7.2,3.6c5.6,2.8,11.3,5.7,16.9,8.5c0.7,0.3,0.9,0.7,0.9,1.4 c0,11.2,0,22.4,0,33.7c0,0.6-0.1,1-0.8,1.3c-7.8,3.9-15.7,7.8-23.5,11.8C65.5,75.1,65.2,75.2,65,75.3z M86.9,56.6 c0-7.5,0-14.9,0-22.4c0-0.3,0.1-0.6-0.2-0.8c-0.8-0.6-1.8-0.7-2.7-1c-3.6-1.1-7.3-2.2-10.9-3.3c-0.6-0.2-0.8,0-0.8,0.6 c0,0.9,0,1.9,0,2.8c0,7.4,0,14.9,0,22.3c0,0.9,0,1.8,0,2.7c0,0.8,0,1.7,0,2.5c0,0.8,0.2,0.8,0.9,0.6c2.8-0.9,5.6-1.7,8.4-2.5 C83.4,57.7,85.2,57.4,86.9,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.1,34.4c0,7.1,0,14.2,0,21.3c-0.4,0.1-0.8,0.1-1.2,0.2c-1.8,0.4-3.7,0.4-5.6,0.9 c-0.3-0.2-0.2-0.5-0.2-0.7c0-7.3,0-14.6,0-21.9c0-0.6,0.1-0.9,0.7-0.6c0.5,0.1,1,0.1,1.5,0.2C46.9,33.9,48.5,34,50.1,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.1,34.4c-1.5-0.4-3.1-0.5-4.7-0.7c-0.5-0.1-1-0.1-1.5-0.2c0-0.3,0.3-0.4,0.5-0.5 c4.2-1.3,8.4-2.5,12.6-3.8c0.6-0.2,0.8,0,0.8,0.6c0,0.9,0,1.9,0,2.8C55.1,33.1,52.6,33.7,50.1,34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.3,56.7c1.8-0.5,3.7-0.5,5.6-0.9c0.4-0.1,0.8-0.1,1.2-0.2c2.5,0.8,5,1.6,7.6,1.8c0,0.7,0,1.5,0,2.2 c0,1.4,0,1.4-1.4,1C52,59.3,47.7,58,43.3,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.9,55.7c0-7.1,0-14.2,0-21.3c0.5-0.4,1.1-0.2,1.7-0.3c1.7-0.3,3.4-0.5,5.1-0.7c0.2,0.2,0.2,0.5,0.2,0.8 c0,7.5,0,14.9,0,22.4C84.5,56.3,82.2,56,79.9,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.7,33.5c-1.7,0.1-3.4,0.3-5.1,0.7c-0.6,0.1-1.2-0.2-1.7,0.3c-2.2-0.7-4.5-1.1-6.8-1.6 c-0.3-0.1-0.6-0.1-0.9-0.2c0-0.9,0-1.9,0-2.8c0-0.6,0.2-0.7,0.8-0.6c3.6,1.1,7.3,2.2,10.9,3.3C84.9,32.8,85.9,32.9,86.7,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.9,55.7c2.3,0.3,4.6,0.6,6.9,0.9c-1.7,0.8-3.5,1.1-5.2,1.7c-2.8,0.9-5.6,1.7-8.4,2.5 c-0.7,0.2-1,0.1-0.9-0.6c0.1-0.8,0-1.7,0-2.5C74.9,57,77.4,56.5,79.9,55.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloudformation);
export default __webpack_public_path__ + "static/media/AWSCloudformation.b45a5e6fcfdd503babe4f527b00bfc06.svg";
export { ForwardRef as ReactComponent };